//  ----------------------------------------------------------------------------
//  Navigation config
//  ----------------------------------------------------------------------------
//
//  Navigation constant directory
//
//  -- Description
//  Source of truth for navigation config values
//

//  -- Containers ---------------------
import AccountContainer from 'containers/Account';
import AdminDashboard from 'containers/AdminDashboard';
import TeacherHome from 'containers/TeacherHome';
import StudentHome from 'containers/StudentHome';
import SuperAdminDataBrowser from 'containers/SuperAdmin/DataBrowser';
import Standard from 'containers/Standard';
import StandardsDashboard from 'containers/StandardsDashboard';
import DisctrictNewDashboard from 'containers/DistrictDataBrowsers';
import Literacy from "containers/Literacy"
import StudentDashboard from 'containers/StudentDashboard';
import DistrictAdmin from 'containers/district_admin';
import AddBook from "containers/addBook"
import EditBookUnits from "containers/addBook/bookUnits"
import EditResources from "containers/addBook/resources"
import EditExams from "containers/addBook/exams"
import EditStory from "containers/addBook/Story"
import EditApExams from "containers/addBook/apexams"
import EditHowToVideos from "containers/addBook/howToVideos"
import Edit1wayTeacherVideo from "modules/1wayTeacherVideo/admin/1wayTeacherVideo"
import Edit1gameVideo from "containers/addBook/1gameVideo"
import Edit1gameYoutubeVideo from "containers/addBook/1gameYoutubeVideo"
import Edit1gameUpdateVideo from "containers/addBook/1gameUpdateVideo"
import bookGrouping from 'containers/addBook/bookGrouping';
import DistrictPreference from "components/AdminExams/Districtpreference"
import DistrictPreferenceReport from "components/AdminExams/proficiencyExam/DistrictpreferenceReport";
import TeacherProficiencyReport from "components/AdminExams/proficiencyExam/TeacherProficiencyReport";
import StandardExam from "components/AdminExams/StandardExam";
import AdminPreference from "components/AdminExams/index"
import Content_exam from "containers/district_admin/content_exam"
import AP_exam from "containers/district_admin/ap_exam"
import Edit1gameGallery from "containers/addBook/1gameGallery"
import ParentHome from "containers/parent/index"
import ParentClasses from "containers/parent/classes"
import BookMap from "containers/admin/bookmaps"
import KeyManage from "containers/admin/bookmaps/keys"
import Rubric from 'modules/adminRubricModule';
import PlacementExam from 'modules/PlacementExam';
import PlacemetExamDistrict from 'modules/PlacementExam/district/PlacementExamDistrict';
import PlacememtExamViewSubmissions from 'modules/PlacementExam/district/PlacememtExamViewSubmissions';
import PlacememtExamViewSubmissionsOwe from 'modules/PlacementExam/district/PlacememtExamViewSubmissionsOwe';
import Ebooklist from 'containers/district_admin/Ebooks';
import AdminWorkSheet from 'modules/workSheet/adminWorksheet';
import InappropriateWordsEditor from 'components/admin/bookmaps/InappropriateWordsManager';
import InappropriateWordLog from 'components/admin/bookmaps/ListInappropriate';
import SentenceStarter from 'modules/sentenceStarter/admin';
import DistrictDataHome from 'containers/admin/OwePages/DistrictDataHome';
import AdminGlobalSearch from 'containers/admin/OwePages/AdminGlobalSearch';
import ListAllAP from 'containers/addBook/ListAllAP';
import MultiFileUploader from 'components/UI/admin/MultifileUploadGallery';
import AudioGalleryAdmin from 'components/UI/admin/AudioGalleryAdmin';
import QuoteModuleAdmin from 'modules/quoteModule/admin';
import TeacherSupportModuleAdmin from 'modules/teacherSupport/admin';
import FeedbackModuleAdmin from 'modules/feedback/admin';
import StandardBasedExam from 'containers/exams/StandardBasedExam';
import UnitExamQuizData from 'containers/exams/UnitExamQuizData'
import StandardExamReport from 'modules/standardExamReport';
import SuperAdminControlPanel from 'containers/SuperAdminControlPanel';

//  -- Routes -------------------------
const student = [
    {
        component: StudentDashboard,
        path: '/student/class',
    },
    {
        component: StudentHome,
        path: '/student/home',
    },
    {
        
        component: StandardBasedExam,
        path: '/standard-based-exam',
    },
    {
        component: UnitExamQuizData,
        path: '/unit-exam-and-quizzes-book'
    },
    {
        component: StandardExamReport,
        path: '/standard-exam-report'
    }
];

const teacher = [
    {
        component: AdminDashboard,
        path: '/admin/class',
    },
    {
        component: AccountContainer,
        path: '/account',
    },
    {
        component: TeacherHome,
        path: '/teacher/home',
    },
    {
        component: StandardBasedExam,
        path: '/standard-based-exam',
    },
    {
        component: UnitExamQuizData,
        path: '/unit-exam-and-quizzes-book'
    },
    {
        component: StandardExamReport,
        path: '/standard-exam-report'
    },
    {
        component: TeacherProficiencyReport,
        path: '/proficiency-report'
    }
];

// this is for district admin
const admin = [
    {
        component: AdminDashboard,
        path: '/admin/class',
    },
    {
        component: StudentDashboard,
        path: '/student/class',
    },
    {
        component: DistrictAdmin,
        path: '/district',
    },
    {
        component: AccountContainer,
        path: '/account',
    },
    {
        component: AddBook,
        path: '/add-book',
    },
    {
        component: EditBookUnits,
        path: '/edit-book-units',
    },
    {
        component: EditResources,
        path: '/edit-resources',
    },
    {
        component: EditExams,
        path: '/edit-exams',
    },
    {
        component: EditStory,
        path: '/edit-story',
    },
    {
        component: EditApExams,
        path: '/edit-ap-exams',
    },
    {
        component: EditHowToVideos,
        path: '/edit-how-to-videos',
    },
    {
        component: Edit1wayTeacherVideo,
        path: '/edit-1way-teacher',
    },
    {
        component: SentenceStarter,
        path: '/sentence-starter',
    },
    {
        component: DisctrictNewDashboard,
        path: '/data-browsers',
    },
    {
        component: Literacy,
        path: '/literacy',
    },
    {
        component: Edit1gameVideo,
        path: '/edit-1game-tutorial',
    },
    {
        component: Edit1gameYoutubeVideo,
        path: '/edit-1game-video',
    },
    {
        component: Edit1gameUpdateVideo,
        path: '/edit-1game-update',
    },
    {
        component: DistrictPreference,
        path: '/proficiency',
    },
    {
        component: DistrictPreferenceReport,
        path: '/proficiency-report',
    },
    {
        component: Content_exam,
        path: '/content_exam',
    },
    {
        component: StandardExam,
        path: '/standard-exam',
    },
    {
        component: StandardExamReport,
        path: '/standard-exam-report',
    },
    {
        component: AP_exam,
        path: '/ap_exams',
    },
    {
        component: Edit1gameGallery,
        path: '/edit-1game-gallery',
    },
    {
        component: PlacementExam,
        path: '/placement_exam',
    },
    {
        component: PlacemetExamDistrict,
        path: '/placement_exam_list',
    },
    {
        component: PlacememtExamViewSubmissions,
        path: '/placement_exam_submissions',
    },
    {
        component: Ebooklist,
        path: '/ebook_list',
    },
    {
        path: '/standard-based-exam',
        component: StandardBasedExam,
    }
];

const director = [
    {
        component: AdminDashboard,
        path: '/admin/class',
    },
    {
        component: AccountContainer,
        path: '/account',
    }
];
const parent = [
    {
        component: ParentHome,
        path: '/parent/class',
    },
    {
        component: AccountContainer,
        path: '/account',
    },
    {
        component: ParentClasses,
        path: '/parent/home',
    }
]

// this is  for  admin
const owe = [
    {
        component: AdminDashboard,
        path: '/admin/class',
    },
    {
        component: DistrictAdmin,
        path: '/district',
    },
    {
        // component: Dashboard,
        component: DistrictDataHome,
        path: '/dashboard',
    },
    {
        component: AdminGlobalSearch,
        path: '/global-admin-search',
    },
    {
        component: AccountContainer,
        path: '/account',
    },
    {
        component: AddBook,
        path: '/add-book',
    },
    {
        component: EditBookUnits,
        path: '/edit-book-units',
    },
    {
        component: EditResources,
        path: '/edit-resources',
    },
    {
        component: EditExams,
        path: '/edit-exams',
    },
    {
        component: bookGrouping,
        path: '/edit-book-grouping',
    },
    {
        component: EditStory,
        path: '/edit-story',
    },
    {
        component: EditApExams,
        path: '/edit-ap-exams',
    },
    {
        component: ListAllAP,
        path: '/edit-all-ap',
    },
    {
        component: EditHowToVideos,
        path: '/edit-how-to-videos',
    },
    {
        component: Edit1wayTeacherVideo,
        path: '/edit-1way-teacher',
    },
    {
        component: SentenceStarter,
        path: '/sentence-starter',
    },
    {
        component: Edit1gameVideo,
        path: '/edit-1game-tutorial',
    },
    {
        component: Edit1gameYoutubeVideo,
        path: '/edit-1game-video',
    },
    {
        component: AdminWorkSheet,
        path: '/worksheet',
    },
    {
        component: Edit1gameUpdateVideo,
        path: '/edit-1game-update',
    },
    {
        component: SuperAdminDataBrowser,
        path: '/data-browsers',
    },
    {
        component: Standard,
        path: '/standard',
    },
    {
        component: StandardsDashboard,
        path: '/standards-dashboard',
    },
    {
        component: AdminPreference,
        path: '/proficiency',
    },
    {
        component: AP_exam,
        path: '/ap_exams',
    },
    {
        component: Edit1gameGallery,
        path: '/edit-1game-gallery',
    },
    {
        component: BookMap,
        path: '/book-maps',
    },
    {
        component: KeyManage,
        path: '/keys',
    },
    {
        component: Rubric,
        path: '/rubric',
    },
    {
        component: PlacementExam,
        path: '/placement_exam',
    },
    {
        component: PlacemetExamDistrict,
        path: '/placement_exam_list',
    },
    {
        component: PlacememtExamViewSubmissionsOwe,
        path: '/placement_exam_submissions',
    },
    {
        component: InappropriateWordsEditor,
        path: '/inappropriate_words',
    },
    {
        component: InappropriateWordLog,
        path: '/inappropriate_words_logs',
    },
    {
        component: MultiFileUploader,
        path: '/image_gallery',
    },
    {
      component: AudioGalleryAdmin,
      path: '/audio_gallery',
    },
      {
        component: QuoteModuleAdmin,
        path: '/quotes',
    },
    {
        component: TeacherSupportModuleAdmin,
        path: '/teacher_support',
    },
    {
        component: FeedbackModuleAdmin,
        path: '/feedback_reports',
    },
    {
        component: SuperAdminControlPanel,
        path: '/super-admin-control-panel',
    },
];

export const generateRoutes = (user) => {
    switch (user?.role) {
        case 'teacher':
            return teacher;
        case 'admin':
            return admin;
        case 'placement_admin':
            return admin;
        case 'director':
            return director;
        case 'parent':
            return parent;
        case 'owe_admin':
        case 'owe_cs':
            return owe;
        default:
            return student;
    }
}

export const generateNavigation = () => {
    
}

export const redirectToHome = (user) =>{
    try{
    const roleWorksheetRedirects = {
        'owe_admin': '/dashboard',
        'admin': '/district',
        'placement_admin': '/placement_exam_list',
        'teacher': '/admin/class?view=home',
        'student': '/student/class',
        'parent': '/parent/class',
    };
    return roleWorksheetRedirects[user?.role] || '-1';
    }catch(error){
        console.log(error, "error");
        return '-1';
    }
}